<template>
  <div class="sejour pt-5">
    <div class="container-fluid col-md-10 pb-5">
      <h1 class="text-white text-center display-4">Découvrez une sélection de nos biens les plus réservés.</h1>
    </div>

    <div class="container-fluid col-md-11">
      <div class="row justify-content-center">
        <div v-for="logement in logementsFiltres.slice(0.4)" :key="logement.id" class="col-md-3 mb-4">
          <div class="card custom-card-width mb-4 h-100">
            <!-- Utilisez v-if pour conditionnellement afficher le contenu -->
            <div v-if="!isLoading">
              <router-link :to="{ name: 'logement-details', params: { id: logement.id } }">
                <img v-if="logementPhotosMap[logement.id]" :src="getPhotoUrl(logementPhotosMap[logement.id].imageName)"
                     class="card-img-top" :alt="logementPhotosMap[logement.id].imageName">
              </router-link>
              <div class="card-body">
                <div class="d-flex align-items-start">
                  <h5>
                    <span class="badge bg-perso p-2 text-white">
                      <i class="fa fa-star mr-2"></i>
                      {{ logement.rating }}
                    </span>
                  </h5>
                </div>
                <div class="d-flex flex-column align-items-start"> <!-- Enveloppez le titre et la description dans une div -->
                  <p class="font-weight-bold">{{ logement.titre }}</p>
                </div>
                <div class="d-flex justify-content-between align-items-center mt-4">
                  <p class="blockquote-footer">
                    {{ logement.capacity }} voyageur{{ logement.capacity > 1 ? 's' : '' }} -
                    {{ logement.chambres }} chambre{{ logement.chambres > 1 ? 's' : '' }} -
                    {{ logement.salledebains }} salle de bain{{ logement.salledebains > 1 ? 's' : '' }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {onMounted, ref} from 'vue';
import axios from 'axios';

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Misenavant',
  computed: {
    logementsFiltres() {
      return this.logements.filter(logement => logement.misenavant === 1);
    },
  },
  setup() {
    const logements = ref([]);
    const logementPhotosMap = ref({});
    const isLoading = ref(true);

    onMounted(async () => {
      try {
        await fetchLogements();
        await fetchPhotos();
        isLoading.value = false;
      } catch (error) {
        console.error('An error occurred:', error);
      }
    });

    const fetchLogements = async () => {
      try {
        const response = await axios.get('https://www.api.moon-suites.com/api/logements');
        logements.value = response.data['hydra:member'].map(logement => ({
          id: logement.id,
          titre: logement.titre,
          description: logement.description,
          rating: logement.rating,
          superficie: logement.superficie,
          misenavant: logement.misenavant,
          capacity: logement.capacity,
          chambres: logement.chambres,
          lits: logement.lits,
          salledebains: logement.salledebains,
          arrondissement:logement.arrondissements,
        }));

        // Ajoutez un message de débogage pour vérifier les données du logement
        console.log("Données des logements récupérées :", logements.value);
      } catch (error) {
        console.error('Erreur lors de la récupération des logements', error);
      }
    };

    const fetchPhotos = async () => {
      try {
        const response = await axios.get('https://www.api.moon-suites.com/api/photos');
        const photosData = response.data['hydra:member'];

        photosData.forEach(photo => {
          const logementId = extractIdFromUrl(photo.id_logements);
          if (!logementPhotosMap.value[logementId]) {
            logementPhotosMap.value[logementId] = {
              imageName: photo.imageName,
            };
          }
        });
      } catch (error) {
        console.error('Erreur lors de la récupération des images', error);
      }
    };

    function extractIdFromUrl(url) {
      const parts = url.split('/');
      return parseInt(parts[parts.length - 1], 10);
    }

    const getPhotoUrl = (imageName) => {
      return `https://www.api.moon-suites.com/images/photos/${imageName}`;
    };

    return {
      logements,
      logementPhotosMap,
      getPhotoUrl,
      isLoading,
    };
  },
};
</script>

<style scoped>
.display-4 {
  font-weight: 600;
}

.card {
  border: none;
  border-radius: 15px;
}

.card:hover {
  transform: scale(1.07); /* Grossissement de 10% */
  transition: transform 0.3s ease; /* Transition fluide */
}

.custom-card-width {
  width: 100%;
}

.card-img-top {
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  height: 30vh;
  object-fit: cover;
}

h5 {
  font-family: Helvetica, sans-serif;
}

p {
  font-family: Helvetica, sans-serif;
  margin-bottom: 0px;
}

.bg-perso {
  background-color: rgb(75, 108, 204);
}

.sejour {
  background-color: #3575A0;
  margin-bottom: 2rem;
  padding-bottom: 3rem;
}

.bg-perso {
  background-color: rgb(75, 108, 204);
}
</style>
